import { Injectable } from '@angular/core';
import { VendorOAuthRegistrationService } from "./Integration/api/vendorOAuthRegistration.service";
import { VendorOAuthRegistration } from './Integration/model/vendorOAuthRegistration';
import { vendorEnum } from '../../../../../assets/config/model/vendorEnums' //'./../../../assets/config/model/vendorEnums';
import { EmailGenerationNS } from './model/ml.EmailGeneration';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  public organizationId: number;
  public vendorId: number;
  private settings;
  constructor(private http: HttpClient,
    // private vendorService?: VendorOAuthRegistrationService,
  ) {
    this.organizationId = 3;
    this.vendorId = vendorEnum.outlook;
  }

  MSALConfigFactory(): Promise<any> {
    let config = this.getConfigurationDetails().then((res: VendorOAuthRegistration) => {
      const obj = {
        auth: {
          clientId: res.clientId,
          //   authority: res.endPointHostUrl,
          //   redirectUri: "http://localhost:4200/",
          //   postLogoutRedirectUri: "http://localhost:4200/",
          //   navigateToLoginRequestUrl: false,
        },
        // cache: {
        //   cacheLocation: "localStorage",
        //   storeAuthStateInCookie: false, // set to true for IE 11
        // },
      }
      this.settings = obj;
      return obj;
    });
    return config.then((res) => res);
  }

  getSettings(): any {
    return this.settings;
  }

  getConfigurationDetails(): Promise<any> {
    return new Promise(() => { });
    // return this.vendorService.lionO36020APIVendorOAuthRegistrationIdGet(this.organizationId, this.vendorId).toPromise().then((res: VendorOAuthRegistration[]) => {
    //   return res;
    // });
  }

  getGenerateEmail(emailGenerationScenario: EmailGenerationNS.EmailGenerationScenarioRequest) {
    // const reqHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    // return this.http.post(`${environment.mlAPI}EmailGeneration/scenario?maxLength=${emailGenerationScenario.maxLength}&recipient=${emailGenerationScenario.recipient}&signature=${emailGenerationScenario.signature}&tone=${emailGenerationScenario.tone.name}`,
    return this.http.post(`${environment.mlAPI}EmailGeneration/scenario`,
      emailGenerationScenario,
      // {
      //   observe: 'response',
      //   responseType: 'text',
      //   headers: reqHeaders
      // }
    );
  }

  getGenerateReply(emailGenerationScenario: EmailGenerationNS.EmailGenerationScenarioRequest) {
    return this.http.post(`${environment.mlAPI}EmailGeneration/email-response`, emailGenerationScenario);
  }
  getGenerateFollowup(emailGenerationScenario: EmailGenerationNS.EmailGenerationScenarioRequest) {
    return this.http.post(`${environment.mlAPI}EmailGeneration/email-followup`, emailGenerationScenario);
  }

  getEmailListDropdown(objectId: number, objectRecordId: number) {
    return this.http.get(`${environment.activity}/LionO360/2.0/API/ObjectEmailAudit/EmailList?objectId=${objectId}&objectRecordId=${objectRecordId}`);
  }

  SetSMTPConfiguration(data) {
    return this.http.post(`${environment.configUrlV2}/IMAPAccountSetting`, data);
  }
  verifySMTPConfiguration(data) {
    return this.http.post(`${environment.integrationUrl2}OtherEmailServer/Verify`, data);
  }
  getSMTPData(){
    return this.http.get(`${environment.configUrlV2}/IMAPAccountSetting/OtherSMTP`);
  }

}